import { sodApi } from "@/services";
import type { EngagementCardData, EngagementDetail, EngagementSearchQuery } from '../../services/types'
import { ClientSearchOption, UserSearchData } from '../../common/models/User'
import { addClient, clientCardSlice, setCurrentEngagement } from '../../features/Client/clientCardSlice'

export const clientsApi = sodApi.injectEndpoints({
  endpoints: (builder) => ({
    listEngagement: builder.query<EngagementCardData[], boolean>({
      query: (isArchived) => ({
        url: `/Engagement/List/${isArchived}`,
        method: 'GET',
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        dispatch(clientCardSlice.actions.setLoading(true));
        dispatch(clientCardSlice.actions.clearEngagmentList());
        try {
          const { data } = await queryFulfilled;
          data.forEach((engagement: EngagementCardData) => {
            dispatch(addClient(engagement))
          })
        } finally {
          dispatch(clientCardSlice.actions.setLoading(false));
        }
      },
    }),
    deleteClient: builder.query<EngagementCardData, string>({
      query: (clientId) => ({
        url: '/Engagement/Delete/' + clientId,
        method: 'POST',
      }),
      onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
        dispatch(clientCardSlice.actions.setLoading(true));
        try {
          await queryFulfilled;
        } finally {
          dispatch(clientCardSlice.actions.setLoading(false));
        }
      },
    }),
    saveClient: builder.mutation<EngagementCardData, EngagementCardData>({
      query: (client) => ({
        url: '/Engagement/Save',
        method: 'POST',
        body: client,
      }),
    }),
    listClient: builder.query<ClientSearchOption[], void>({
      query: () => ({
        url: '/Client/List',
        method: 'GET',
      }),
    }),
    usersList: builder.query<UserSearchData[], void>({
      query: (name) => ({
        url: `/User/Search/${name}`,
        method: 'GET',
      }),
    }),
    saveNewClient: builder.mutation<void, { id: string; clientName: string; engagements: never[] }>({
      query: (client) => ({
        url: `/Client/Save`,
        method: 'POST',
        body: client,
      }),
    }),
    searchEngagements: builder.mutation<EngagementCardData[], EngagementSearchQuery>({
      query: (data) => ({
        url: '/Engagement/Search',
        method: 'POST',
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        dispatch(clientCardSlice.actions.setLoading(true));
        dispatch(clientCardSlice.actions.clearEngagmentList());
        try {
          const { data } = await queryFulfilled;
          data.forEach((engagement: EngagementCardData) => {
            dispatch(addClient(engagement))
          })
        } finally {
          dispatch(clientCardSlice.actions.setLoading(false));
        }
      }
    }),
    getEngagement: builder.query<EngagementCardData, string>({
      query: (id) => ({
        url: `/Engagement/${id}`,
        method: 'GET',
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        dispatch(clientCardSlice.actions.setLoading(true));
        try {
          const { data } = await queryFulfilled;
        
          dispatch(setCurrentEngagement({ 
            clientID: data.clientId,
            engagementID: data.id,
            engagementName: data.engagementName,
            clientName: data.clientName,
            signOffDueDate: data.signOffDueDate,
            team: data.team || [],
            isArchived: data.isArchived,
          } as EngagementDetail));
        } finally {
          dispatch(clientCardSlice.actions.setLoading(false));
        }
      },
    }),
  }),
})

export const {
  useListEngagementQuery,
  useLazyListEngagementQuery,
  useLazyDeleteClientQuery,
  useSaveClientMutation,
  useLazyListClientQuery,
  useLazyUsersListQuery,
  useSaveNewClientMutation,
  useSearchEngagementsMutation,
  useLazyGetEngagementQuery,
} = clientsApi
